import React, { FC, MouseEventHandler, useEffect, useRef } from 'react';
import Close from '../../../Icons/Close.svg';
import { WithTranslations, withTranslations } from '../../../utils/withTranslations';
import { Template } from '../../../web-api/domain/template';
import s from './InfoModal.scss';

type InfoModalProps = WithTranslations & {
  template: Template | undefined;
  editorLink: string | undefined;
  onEditorClick: () => void;
  onClose: () => void;
};
const InfoModalCmp: FC<InfoModalProps> = ({ t, template, editorLink, onEditorClick, onClose }) => {
  const dialogRef = useRef<HTMLDialogElement>(null);

  const handleDialogClick: MouseEventHandler<HTMLDialogElement> = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  useEffect(() => {
    if (template) {
      dialogRef.current.showModal();
    } else if (dialogRef.current?.open) {
      dialogRef.current.close();
    }
  }, [template]);

  return (
    <dialog ref={dialogRef} onClick={handleDialogClick} className={s.infoModal}>
      <main>
        <h1>{template?.title}</h1>
        <h3>{t('template.goodFor')}</h3>
        <p>{template?.info.goodFor}</p>
        <h3>{t('template.description')}</h3>
        <p>{template?.info.description}</p>
        <a href={editorLink} onClick={onEditorClick}>
          {t('viewModal.edit')}
        </a>
        <button className={s.close} onClick={() => onClose()}>
          <Close width={18} height={18} fill="#151414" />
        </button>
      </main>
    </dialog>
  );
};

export const InfoModal = withTranslations(InfoModalCmp);
